import { jsxs as s, jsx as a } from "react/jsx-runtime";
const l = ({
  width: t,
  height: o,
  className: n
}) => /* @__PURE__ */ s(
  "svg",
  {
    className: n,
    "data-name": "Icon ionic-ios-desktop",
    height: o,
    id: "Icon_ionic-ios-desktop",
    viewBox: "0 0 14.737 12.628",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ a(
        "path",
        {
          d: "M17.564,29.513a.168.168,0,0,0-.138-.141l-.734-.062a1.143,1.143,0,0,1-.734-.931l-.039-.253H12.893l-.039.25a1.149,1.149,0,0,1-.734.931l-.734.063a.179.179,0,0,0-.138.141.169.169,0,0,0,.168.191H17.4A.166.166,0,0,0,17.564,29.513Z",
          "data-name": "Path 1",
          fill: "#656565",
          id: "Path_1",
          transform: "translate(-7.038 -17.073)"
        }
      ),
      /* @__PURE__ */ a(
        "path",
        {
          d: "M16.753,4.73a.8.8,0,0,0-.559-.23H3.046a.789.789,0,0,0-.559.23.8.8,0,0,0-.237.559v8.947a.8.8,0,0,0,.237.559.779.779,0,0,0,.553.23H16.2a.774.774,0,0,0,.553-.23.8.8,0,0,0,.237-.559V5.289A.784.784,0,0,0,16.753,4.73ZM9.618,14.237a.263.263,0,1,1,.263-.263A.264.264,0,0,1,9.618,14.237Zm6.707-1.316H2.914a.132.132,0,0,1-.132-.132V5.421a.4.4,0,0,1,.395-.395H16.062a.4.4,0,0,1,.395.395v7.368A.132.132,0,0,1,16.325,12.921Z",
          "data-name": "Path 2",
          fill: "#656565",
          id: "Path_2",
          transform: "translate(-2.25 -4.5)"
        }
      )
    ]
  }
);
export {
  l as Content
};
